import { useCallback } from 'react';
import { m } from 'framer-motion';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CustomExpandableSection({
  title,
  renderContent,
  titleProps,
  caretSpaceProps = {},
  titleTypography = 'heading-100',
  caretSize = '200',
  actions,
  open,
  onOpenChange
}) {
  const Header = useCallback(({
    children
  }) => {
    return /*#__PURE__*/_jsx(Flex, Object.assign({
      alignItems: "center",
      justifyContent: "space-between",
      gap: "400"
    }, titleProps, {
      children: children
    }));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const Title = useCallback(({
    titleText
  }) => {
    return /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: titleTypography,
      children: titleText
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const caretCssStyles = useMapTokenPropsToCSS(caretSpaceProps);
  const Caret = useCallback(({
    open: isOpen
  }) => {
    return /*#__PURE__*/_jsx(m.div, {
      role: "img",
      style: Object.assign({}, caretCssStyles, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }),
      animate: {
        rotate: isOpen ? 90 : 0
      },
      children: /*#__PURE__*/_jsx(RightIcon, {
        color: "icon-interactive-hover",
        size: caretSize
      })
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const ContentWrapper = ({
    open: isOpen
  }) => {
    if (!isOpen) {
      return null;
    }
    return renderContent();
  };
  return /*#__PURE__*/_jsx(ExpandableSection, {
    open: open,
    onOpenChange: onOpenChange,
    titleText: title,
    Header: Header,
    Caret: Caret,
    Title: Title,
    ContentWrapper: ContentWrapper,
    actions: actions,
    children: /*#__PURE__*/_jsx("div", {})
  });
}